import client from '../httpClient';

// 【mokuhyoMst005】キマリス目標削除
const deleteKimarisTarget = (targetId) => {
  return client.delete(`/keymalis-target-settings/${targetId}`);
};

export default deleteKimarisTarget;
